import React from "react"
import EditableTableHolder from "../components/EditableTableHolder"
import { Button, Modal, Header } from "semantic-ui-react"
import { connect } from "react-redux"
import {
  search,
  refresh,
  openPage,
  exportData,
  editSupply,
  sort,
  filter,
  clear,
  deleteSupply,
  editPurchase,
} from "../ducks/tabularData/stock"
import { getData, addItemsToDiscount } from "../ducks/discounts"
import { authorize, authorizeAction } from "../decorators/authorize"
import requireStore from "../decorators/requireStore"
import { supplyPage } from "../config/routesInfo"
import { canReport } from "../config/permissions"
import { withTranslation } from "react-i18next"
import { addToCategory } from "../ducks/product"
import { getProducts } from "../ducks/products"

const columns = [
  {
    title: "barcode",
    name: "barcode",
    dataType: "string",
    sortable: true,
  },
  {
    title: "supplyTitle",
    name: "name",
    dataType: "string",
    editable: true,
    sortable: true,
    filters: ["values"],
  },
  {
    title: "purchasePrice",
    name: "purchasePrice",
    dataType: "number",
    editable: true,
    sortable: true,
    filters: ["range"],
    // editable: true,
    // sortable: true,
    // filters: ["range"],
  },
  {
    title: "priceSale",
    name: "salePrice",
    dataType: "number",
    editable: true,
    sortable: true,
    filters: ["range"],
  },
  {
    title: "stock",
    name: "remainder",
    dataType: "number",
    sortable: true,
    filters: ["range"],
  },
  {
    title: "unitsMeasuring",
    name: "shortName",
    dataType: "string",
  },
  {
    title: "total",
    name: "total",
    dataType: "number",
  },
  {
    title: "discount",
    name: "",
    dataType: "number",
    render: (item) => parseInt(item.discount || 0) + "%",
  },
  // {
  //   // title: "",
  //   name: "button",
  //   render: (item) => (
  //     <Button id={item.id} content="Добавить в акцию" color="green" />
  //   ),
  // },
]

const innerColumns = [
  {
    title: "datePurchase",
    name: "at",
    dataType: "date",
  },
  {
    title: "purchasePrice",
    name: "purchasePrice",
    dataType: "number",
    editable: true,
  },
  // {
  //   title: "Остаток, шт",
  //   name: "remainder",
  //   dataType: "number",
  // },
  {
    title: "purchased",
    name: "quantity",
    dataType: "number",
    editable: true,
  },
  {
    title: "total",
    name: "total",
    dataType: "number",
  },
  {
    title: "unitsMeasuring",
    name: "measureName",
    dataType: "string",
  },
]

@authorize(...supplyPage.permissions)
@requireStore()
@withTranslation()
@connect(
  (state) => ({
    activeFilters: state.stock.filters,
    sortedBy: state.stock.sortedBy,
    sortedAsc: state.stock.sortedAsc,
    data: state.stock.data,
    isLoading: state.stock.pendingRequests > 0,
    pagesCount: state.stock.totalPages,
    currentPage: state.stock.currentPage,
    currentStoreId: state.profile.currentStore.id,
    totalCount: state.stock.totalCount,
    discounts: state.discounts.data,
    categories: state.products.data,
  }),
  (dispatch) => ({
    onSearch: (...data) => dispatch(search(...data)),
    refresh: () => dispatch(refresh()),
    clear: () => dispatch(clear()),
    onExport: (...data) => dispatch(exportData(...data)),
    onPageSelect: (...data) => dispatch(openPage(...data)),
    onEdit: (...data) => dispatch(editSupply(...data)),
    addItemsToDiscount: (data) => dispatch(addItemsToDiscount(data)),
    // onDelete: (...data) => dispatch(deleteSupply(...data)),
    onSort: (...data) => dispatch(sort(...data)),
    changeFilters: (...data) => dispatch(filter(...data)),
    onPurchaseEdit: (...data) => dispatch(editPurchase(...data)),
    getDiscounts: () => dispatch(getData()),
    addToCategory: (stockId, categoryId) =>
      dispatch(addToCategory(stockId, categoryId)),
    getCategories: () => dispatch(getProducts()),
  }),
)
export default class SupplyPage extends React.Component {
  state = {
    modal: false,
  }
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refresh } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refresh()
    }
  }

  componentDidMount() {
    this.props.refresh()
    this.props.getDiscounts()
    this.props.getCategories()
    const { onSort } = this.props
    onSort("name")
  }

  componentWillUnmount() {
    this.props.clear()
  }

  log(item) {}

  render() {
    const {
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      isLoading,
      currentPage,
      pagesCount,
      onSearch,
      onPageSelect,
      onExport,
      onEdit,
      categories,
      // onDelete,
      onSort,
      changeFilters,
      onPurchaseEdit,
      totalCount,
      discounts,
      addItemsToDiscount,
      addToCategory,
      refresh,
      t,
    } = this.props
    const onAdd = () => true
    const tableData = {
      columns,
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      isLoading,
      onEdit,
      onAdd,
      // onDelete,
      onSort,
      changeFilters,
    }
    const innerTable = {
      propName: "purchases",
      title: "Информация о закупке",
      tableData: {
        columns: innerColumns,
        data: [],
        onEdit: onPurchaseEdit,
      },
    }

    return (
      <EditableTableHolder
        title={t("supplyPage")}
        info={
          <div>
            <p>
              {t(
                "In this section you can observe detailed information for each of the goods you have, namely",
              )}
            </p>
            <ul>
              <li>{t("supplyTitle")}</li>
              <li>Штрих-код</li>
              <li>{t("Purchase price")}</li>
              <li>{t("priceSale2")}</li>
              <li>{t("stockBalance")}</li>
              <li>{t("Unit of measure")}</li>
              <li>{t("The total cost of the sale of goods")}</li>
              <li>{t("Setted discount")}</li>
            </ul>
            <p>{t("Click on a product for more information")}</p>
            <p>
              {t(
                "Once you have added the stocks, add the good ones and click on the 'Add to stocks' item below",
              )}
            </p>
          </div>
        }
        currentPage={currentPage}
        pagesCount={pagesCount}
        searchInfo="Поиск по штрих-коду или наименованию"
        exportInfo="Экспорт"
        onExport={authorizeAction(canReport).onFail((callback) => callback())(
          onExport,
        )}
        onPageSelect={onPageSelect}
        onSearch={onSearch}
        tableData={tableData}
        isLoading={isLoading}
        innerTable={innerTable}
        totalCount={totalCount || 0}
        discountOptions={discounts.map((disco) => ({
          key: disco.id,
          value: disco.id,
          text: disco.title,
        }))}
        addItemsToDiscount={addItemsToDiscount}
        addToCategory={addToCategory}
        supplyRefresh={refresh}
        categories={categories}
        barcodable={true}
      />
    )
  }
}
